// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    z-index: -1;
}
.pos_rel{
    position: relative;
    background-color: rgb(0, 123, 255);
    width: 100%;
    min-height: 100px;
    height: max-content;
    fill-opacity: 0.5;
    padding: 10px;
    bottom: 0%;
}
.scroll-disabling{
    overflow: hidden;
}
#firsthead{
    width:100%;
    height:550px;
    /* background-color:red; */
    font-family: 'Georgia', serif;
    margin-bottom: 180px;
}
.head-image{
    width:100%;
    height: 700px;
}
.sub-image{
    max-width:100%;
}
@media (max-width:1800px){
    .head-image{
        height: 620px; 
    }
    .sub-image{
        max-width:100%;
    }
    #firsthead{
       margin-bottom: 90px;
    }
}
@media (max-width:1400px){
    .head-image{
        height: 600px; 
    }
    .sub-image{
        max-width:100%;
    }
    #firsthead{
        margin-bottom: 80px;
     }
}
@media (max-width:1100px){
    .head-image{
        height: 550px; 
    }
    .sub-image{
        max-width:100%;
    }
    #firsthead{
        margin-bottom: 0px;
     }
}
@media (max-width:900px){
    .head-image{
        height: 600px; 
    }
    .sub-image{
        max-width:100%;
    }
    #firsthead{
        margin-bottom: 70px;
     }
}
@media (max-width:500px){
    .head-image{
        height: 550px; 
    }
    .sub-image{
        max-width:100%;
    }
    #firsthead{
        margin-bottom: -20px;
    }
}
.subdiv1{
    background-color: white;
    height: 130px;
    margin-left: 0px;
}
.subdiv1:hover {
    background-color: blue;
}
.subdiv1:active {
    background-color: blue;
}
.coldes{
    position: relative;
    padding: 10px 20px 0px 20px;
}
.bottom-text {
    position: absolute;
    bottom: 20px;
    word-wrap: break-word;
overflow-wrap: break-word;
white-space: normal;

}
.bottom-text a{
    color:black;
    word-wrap: break-word;
overflow-wrap: break-word;
white-space: normal;

}
.coldes{
    display:block;
}
.colpoints{
    display:inline-block;
}
@media (min-width:1300px) {
    .coldes h4{
        font-size:23px;
    }
    .sub-image span{
        font-size:32px;   
    }
}
@media (max-width:1300px) {
    .coldes h4{
        font-size:20px;
    }
    .sub-image span{
        font-size:20px;   
    }
}
@media (max-width:992px) {
    .coldes{
        display:none;
        overflow: hidden;
        
    }  
    .colpoints{
        display:inline-block;
    }

}
.imgbeliebt{
    height:205px;
}
@media (max-width:1201px) {
    .imgbeliebt{
        height:150px;
    }
}
@media (max-width:992px) {
    .imgbeliebt{
        height:111px;
    }
}
@media (max-width:768px) {
    .imgbeliebt{
        height:250px;
    }
}
@media (max-width:500px) {
    .imgbeliebt{
        height:200px;
    }
}
.divhauptleistung{
    height: 300px;
}
.h3hauptleistung{
    font-size: normal;
}
.h4hauptleistung{
    font-size: normal;
}
.h5hauptleistung{
    font-size: normal;
}
.phauptleistung{
    font-size: normal;
}
.ahauptleistung{
    font-size: normal;
}
.h4itpartner{
    font-size: normal;
    font-weight: 500;
}
.h3itpartner{
    font-size: normal;
    font-weight: 500;
}
.h5itpartner{
    font-size: normal;
}
@media (max-width:576px) {
    .divhauptleistung{
        height: 240px;
    }
    .h3hauptleistung{
        font-size: 15px;
    }
    .h4hauptleistung{
        font-size: 15px;
    }
    .h5hauptleistung{
        font-size: 13px;
    }
    .phauptleistung{
        font-size: 13px;
    }
    .ahauptleistung{
        font-size:13px;
    }
    .h4itpartner{
        font-size: 15px;
        font-weight: bold;
    }
    .h3itpartner{
        font-size: 16px;
        font-weight: bold;
    }
    .h5itpartner{
        font-size: 14px;
    }
}
.partnerslider{
    height:550px;
}
@media (max-width:992px) {
    .partnerslider{
        height:400px;
    }
} 
@media (max-width:500px) {
    .partnerslider{
        height:300px;
    }
}
form {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 90%;
    margin:auto;
}
input, textarea {
    padding: 8px;
    font-size: 16px;
    width: 100%;
    box-sizing: border-box;
}
.buttonform {
    padding: 10px;
    font-size: 16px;
    cursor: pointer;
    background-color: #007bff;
    color: white;
    border: none;
}
.carousel-bg .overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.4); /* dark overlay */
    z-index: 1; /* Lower z-index */
    pointer-events: none; /* This is key to allow clicking through */
}
.carousel-caption {
    position: absolute;
    bottom: 20px;
    z-index: 2; /* Above overlay */
    color: white;
}
@keyframes fadeIn {
    from { opacity: 0 }
    to { opacity: 1 }
}
@keyframes scaleIn {
    from { transform: scale(0.95); opacity: 0 }
    to { transform: scale(1); opacity: 1 }
}
@keyframes fadeOut {
    from { opacity: 1; }
    to { opacity: 0; }
}

.divpoint{
 width:90%;
 height: 36px; 
 margin:auto;
}
.point{
    margin-top:-30px;
    font-size:50px; 
    padding-right:2%;
    padding-left:2%;
}

@media screen and (min-width: 500px) and (max-width: 850px) {
    .divpoint{
        width:80%;
        height: 36px; 
        margin:auto;
       }
       .point{
           margin-top:-42px;
           font-size:60px; 
           padding-right:2%;
           padding-left:2%;
       }
} 

@media screen and (min-width: 850px) {
    .divpoint{
        width:70%;
        height: 36px; 
        margin:auto;
       }
       .point{
           margin-top:-55px;
           font-size:70px; 
           padding-right:2.5%;
           padding-left:2.5%;
       }
} 

@media screen and (max-width: 500px) {
    .imageoverlay{
        width: 200px;
        height: 150px;
        font-size: normal;
    }
}
@media screen and (min-width: 500px) and (max-width: 800px) {
    .imageoverlay{
        width: 230px;
        height: 180px;
        font-size: normal;
    }
}
@media screen and (min-width: 800px) and (max-width: 1200px) {
    .imageoverlay{
        width: 280px;
        height: 220px;
        font-size: 18px;
    }
}
@media screen and (min-width: 1200px) {
    .imageoverlay{
        width: 280px;
        height: 220px;
        font-size: 20px;
    }
}




@media screen and (max-width: 500px) {
    .hotlimg{
        width: 78%
    }
}
@media screen and (min-width: 500px) and (max-width: 800px) {
    .hotlimg{
        width: 50%
    }
}
@media screen and (min-width: 800px) and (max-width: 1200px) {
    .hotlimg{
        width: 50%
    }
}
@media screen and (min-width: 1200px) {
    .hotlimg{
        width: 40%
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/style/HomeComponent.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,YAAY;IACZ,0BAA0B;IAC1B,6BAA6B;IAC7B,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;OACG,mBAAmB;IACtB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,mBAAmB;KACtB;AACL;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;KACrB;AACL;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,mBAAmB;KACtB;AACL;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,oBAAoB;IACxB;AACJ;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB,yBAAyB;AACzB,mBAAmB;;AAEnB;AACA;IACI,WAAW;IACX,qBAAqB;AACzB,yBAAyB;AACzB,mBAAmB;;AAEnB;AACA;IACI,aAAa;AACjB;AACA;IACI,oBAAoB;AACxB;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,YAAY;QACZ,gBAAgB;;IAEpB;IACA;QACI,oBAAoB;IACxB;;AAEJ;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,WAAW;AACf;AACA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,8BAA8B,EAAE,iBAAiB;IACjD,UAAU,EAAE,kBAAkB;IAC9B,oBAAoB,EAAE,0CAA0C;AACpE;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU,EAAE,kBAAkB;IAC9B,YAAY;AAChB;AACA;IACI,OAAO,WAAW;IAClB,KAAK,WAAW;AACpB;AACA;IACI,OAAO,sBAAsB,EAAE,WAAW;IAC1C,KAAK,mBAAmB,EAAE,WAAW;AACzC;AACA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;CACC,SAAS;CACT,YAAY;CACZ,WAAW;AACZ;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,SAAS;QACT,YAAY;QACZ,WAAW;OACZ;OACA;WACI,gBAAgB;WAChB,cAAc;WACd,gBAAgB;WAChB,eAAe;OACnB;AACP;;AAEA;IACI;QACI,SAAS;QACT,YAAY;QACZ,WAAW;OACZ;OACA;WACI,gBAAgB;WAChB,cAAc;WACd,kBAAkB;WAClB,iBAAiB;OACrB;AACP;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,YAAY;QACZ,aAAa;QACb,eAAe;IACnB;AACJ;AACA;IACI;QACI,YAAY;QACZ,aAAa;QACb,eAAe;IACnB;AACJ;;;;;AAKA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ","sourcesContent":["body{\n    z-index: -1;\n}\n.pos_rel{\n    position: relative;\n    background-color: rgb(0, 123, 255);\n    width: 100%;\n    min-height: 100px;\n    height: max-content;\n    fill-opacity: 0.5;\n    padding: 10px;\n    bottom: 0%;\n}\n.scroll-disabling{\n    overflow: hidden;\n}\n#firsthead{\n    width:100%;\n    height:550px;\n    /* background-color:red; */\n    font-family: 'Georgia', serif;\n    margin-bottom: 180px;\n}\n.head-image{\n    width:100%;\n    height: 700px;\n}\n.sub-image{\n    max-width:100%;\n}\n@media (max-width:1800px){\n    .head-image{\n        height: 620px; \n    }\n    .sub-image{\n        max-width:100%;\n    }\n    #firsthead{\n       margin-bottom: 90px;\n    }\n}\n@media (max-width:1400px){\n    .head-image{\n        height: 600px; \n    }\n    .sub-image{\n        max-width:100%;\n    }\n    #firsthead{\n        margin-bottom: 80px;\n     }\n}\n@media (max-width:1100px){\n    .head-image{\n        height: 550px; \n    }\n    .sub-image{\n        max-width:100%;\n    }\n    #firsthead{\n        margin-bottom: 0px;\n     }\n}\n@media (max-width:900px){\n    .head-image{\n        height: 600px; \n    }\n    .sub-image{\n        max-width:100%;\n    }\n    #firsthead{\n        margin-bottom: 70px;\n     }\n}\n@media (max-width:500px){\n    .head-image{\n        height: 550px; \n    }\n    .sub-image{\n        max-width:100%;\n    }\n    #firsthead{\n        margin-bottom: -20px;\n    }\n}\n.subdiv1{\n    background-color: white;\n    height: 130px;\n    margin-left: 0px;\n}\n.subdiv1:hover {\n    background-color: blue;\n}\n.subdiv1:active {\n    background-color: blue;\n}\n.coldes{\n    position: relative;\n    padding: 10px 20px 0px 20px;\n}\n.bottom-text {\n    position: absolute;\n    bottom: 20px;\n    word-wrap: break-word;\noverflow-wrap: break-word;\nwhite-space: normal;\n\n}\n.bottom-text a{\n    color:black;\n    word-wrap: break-word;\noverflow-wrap: break-word;\nwhite-space: normal;\n\n}\n.coldes{\n    display:block;\n}\n.colpoints{\n    display:inline-block;\n}\n@media (min-width:1300px) {\n    .coldes h4{\n        font-size:23px;\n    }\n    .sub-image span{\n        font-size:32px;   \n    }\n}\n@media (max-width:1300px) {\n    .coldes h4{\n        font-size:20px;\n    }\n    .sub-image span{\n        font-size:20px;   \n    }\n}\n@media (max-width:992px) {\n    .coldes{\n        display:none;\n        overflow: hidden;\n        \n    }  \n    .colpoints{\n        display:inline-block;\n    }\n\n}\n.imgbeliebt{\n    height:205px;\n}\n@media (max-width:1201px) {\n    .imgbeliebt{\n        height:150px;\n    }\n}\n@media (max-width:992px) {\n    .imgbeliebt{\n        height:111px;\n    }\n}\n@media (max-width:768px) {\n    .imgbeliebt{\n        height:250px;\n    }\n}\n@media (max-width:500px) {\n    .imgbeliebt{\n        height:200px;\n    }\n}\n.divhauptleistung{\n    height: 300px;\n}\n.h3hauptleistung{\n    font-size: normal;\n}\n.h4hauptleistung{\n    font-size: normal;\n}\n.h5hauptleistung{\n    font-size: normal;\n}\n.phauptleistung{\n    font-size: normal;\n}\n.ahauptleistung{\n    font-size: normal;\n}\n.h4itpartner{\n    font-size: normal;\n    font-weight: 500;\n}\n.h3itpartner{\n    font-size: normal;\n    font-weight: 500;\n}\n.h5itpartner{\n    font-size: normal;\n}\n@media (max-width:576px) {\n    .divhauptleistung{\n        height: 240px;\n    }\n    .h3hauptleistung{\n        font-size: 15px;\n    }\n    .h4hauptleistung{\n        font-size: 15px;\n    }\n    .h5hauptleistung{\n        font-size: 13px;\n    }\n    .phauptleistung{\n        font-size: 13px;\n    }\n    .ahauptleistung{\n        font-size:13px;\n    }\n    .h4itpartner{\n        font-size: 15px;\n        font-weight: bold;\n    }\n    .h3itpartner{\n        font-size: 16px;\n        font-weight: bold;\n    }\n    .h5itpartner{\n        font-size: 14px;\n    }\n}\n.partnerslider{\n    height:550px;\n}\n@media (max-width:992px) {\n    .partnerslider{\n        height:400px;\n    }\n} \n@media (max-width:500px) {\n    .partnerslider{\n        height:300px;\n    }\n}\nform {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 90%;\n    margin:auto;\n}\ninput, textarea {\n    padding: 8px;\n    font-size: 16px;\n    width: 100%;\n    box-sizing: border-box;\n}\n.buttonform {\n    padding: 10px;\n    font-size: 16px;\n    cursor: pointer;\n    background-color: #007bff;\n    color: white;\n    border: none;\n}\n.carousel-bg .overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background: rgba(0, 0, 0, 0.4); /* dark overlay */\n    z-index: 1; /* Lower z-index */\n    pointer-events: none; /* This is key to allow clicking through */\n}\n.carousel-caption {\n    position: absolute;\n    bottom: 20px;\n    z-index: 2; /* Above overlay */\n    color: white;\n}\n@keyframes fadeIn {\n    from { opacity: 0 }\n    to { opacity: 1 }\n}\n@keyframes scaleIn {\n    from { transform: scale(0.95); opacity: 0 }\n    to { transform: scale(1); opacity: 1 }\n}\n@keyframes fadeOut {\n    from { opacity: 1; }\n    to { opacity: 0; }\n}\n\n.divpoint{\n width:90%;\n height: 36px; \n margin:auto;\n}\n.point{\n    margin-top:-30px;\n    font-size:50px; \n    padding-right:2%;\n    padding-left:2%;\n}\n\n@media screen and (min-width: 500px) and (max-width: 850px) {\n    .divpoint{\n        width:80%;\n        height: 36px; \n        margin:auto;\n       }\n       .point{\n           margin-top:-42px;\n           font-size:60px; \n           padding-right:2%;\n           padding-left:2%;\n       }\n} \n\n@media screen and (min-width: 850px) {\n    .divpoint{\n        width:70%;\n        height: 36px; \n        margin:auto;\n       }\n       .point{\n           margin-top:-55px;\n           font-size:70px; \n           padding-right:2.5%;\n           padding-left:2.5%;\n       }\n} \n\n@media screen and (max-width: 500px) {\n    .imageoverlay{\n        width: 200px;\n        height: 150px;\n        font-size: normal;\n    }\n}\n@media screen and (min-width: 500px) and (max-width: 800px) {\n    .imageoverlay{\n        width: 230px;\n        height: 180px;\n        font-size: normal;\n    }\n}\n@media screen and (min-width: 800px) and (max-width: 1200px) {\n    .imageoverlay{\n        width: 280px;\n        height: 220px;\n        font-size: 18px;\n    }\n}\n@media screen and (min-width: 1200px) {\n    .imageoverlay{\n        width: 280px;\n        height: 220px;\n        font-size: 20px;\n    }\n}\n\n\n\n\n@media screen and (max-width: 500px) {\n    .hotlimg{\n        width: 78%\n    }\n}\n@media screen and (min-width: 500px) and (max-width: 800px) {\n    .hotlimg{\n        width: 50%\n    }\n}\n@media screen and (min-width: 800px) and (max-width: 1200px) {\n    .hotlimg{\n        width: 50%\n    }\n}\n@media screen and (min-width: 1200px) {\n    .hotlimg{\n        width: 40%\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
